<template>
  <div id="main-listado-contrato-fechas">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop desktop :listado="listado" />
    </template>
    <template v-else>
      <desktop :listado="listado" />
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoContratoFechas',
  components: {
    Desktop,
    // Mobile,
  },
  props: {
    listado: Array,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
